import React, { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';

export const SITE_URL = 'https://www.allesbon.be';

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export const Seo = ({ title, description, path, noindex = false }) => {
  useEffect(() => {
    const canonical = `${SITE_URL}${path || window.location.pathname}`;
    document.title = title;
    upsertMeta('name', 'description', description);
    upsertMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', canonical);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:locale', 'nl_BE');
    upsertMeta('property', 'og:site_name', 'AllesBon');
    upsertMeta('property', 'og:image', `${SITE_URL}/logo.png`);
    upsertLink('canonical', canonical);
  }, [title, description, path, noindex]);

  return null;
};

const PAGE_SEO = [
  {
    path: '/',
    exact: true,
    title: 'Cadeaubon kopen van lokale winkels in Vlaanderen | AllesBon',
    description: 'Koop online een digitale cadeaubon van lokale winkels, restaurants en handelaars in Vlaanderen. Direct in je mailbox. Ontdek het aanbod op AllesBon.',
  },
  {
    path: '/over-ons',
    exact: true,
    title: 'Cadeaubonnen online verkopen als handelaar | AllesBon',
    description: 'Zet jouw lokale zaak op AllesBon en verkoop digitale cadeaubonnen zonder maandelijkse kosten. Je betaalt enkel €2,99 per verkochte bon.',
  },
  {
    path: '/contact',
    exact: true,
    title: 'Contact | AllesBon cadeaubonnen',
    description: 'Vraag of opmerking over AllesBon? Neem contact op. We helpen je graag met cadeaubonnen kopen of verkopen.',
  },
  {
    path: '/demo',
    exact: true,
    title: 'Demo aanvragen | AllesBon',
    description: 'Boek een gratis demo van AllesBon en ontdek hoe je digitale cadeaubonnen online verkoopt voor jouw zaak.',
  },
  {
    path: '/cart',
    exact: true,
    noindex: true,
    title: 'Winkelwagen | AllesBon',
    description: 'Bekijk de cadeaubonnen in je winkelwagen.',
  },
  {
    path: '/checkout',
    exact: true,
    noindex: true,
    title: 'Bestellen | AllesBon',
    description: 'Rond je bestelling van digitale cadeaubonnen af.',
  },
  {
    path: '/success',
    exact: true,
    noindex: true,
    title: 'Bestelling gelukt | AllesBon',
    description: 'Je cadeaubon is besteld.',
  },
  {
    path: '/cancel',
    exact: true,
    noindex: true,
    title: 'Betaling mislukt | AllesBon',
    description: 'De betaling is niet gelukt. Probeer opnieuw.',
  },
  {
    path: '/support-success',
    exact: true,
    noindex: true,
    title: 'Bericht verzonden | AllesBon',
    description: 'Je bericht is verzonden.',
  },
  {
    path: '/order/:id/pay',
    exact: true,
    noindex: true,
    title: 'Betalen | AllesBon',
    description: 'Rond de betaling van je cadeaubon af.',
  },
];

export const RouteSeo = () => {
  const { pathname } = useLocation();
  const page = PAGE_SEO.find((route) => matchPath(pathname, { path: route.path, exact: route.exact }));

  if (page) {
    return (
      <Seo
        title={page.title}
        description={page.description}
        path={pathname}
        noindex={Boolean(page.noindex)}
      />
    );
  }

  if (
    matchPath(pathname, { path: '/products/:organizationSlug', exact: true })
    || matchPath(pathname, { path: '/campagne/:slug', exact: true })
  ) {
    return null;
  }

  return (
    <Seo
      title="Pagina niet gevonden | AllesBon"
      description="Deze pagina bestaat niet. Ga terug naar de AllesBon webshop voor lokale cadeaubonnen."
      path={pathname}
      noindex
    />
  );
};
